import React from 'react';

export default function PrivacyPage() {
  return (
    <div className="max-w-4xl mx-auto py-10 px-4 space-y-8">
      <h1 className="text-2xl font-bold text-gray-900">プライバシーポリシー</h1>
      <p className="text-sm text-gray-500">最終更新日：2026年3月14日</p>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold text-gray-800">1. 事業者情報</h2>
        <p className="text-sm text-gray-700">
          株式会社木村技研（以下「当社」）は、本サービス「みんなで何切る」（以下「本サービス」）における
          ユーザーの個人情報の取扱いについて、以下のとおりプライバシーポリシーを定めます。
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold text-gray-800">2. 収集する情報</h2>
        <ul className="text-sm text-gray-700 space-y-1 list-disc list-inside">
          <li>X（旧Twitter）アカウント情報（ユーザーID・表示名・アイコン画像URL）</li>
          <li>投稿した画像・テキスト・投票データ</li>
          <li>決済に関する情報（Stripeを通じて処理。カード番号等は当社サーバーに保存しません）</li>
          <li>アクセスログ（IPアドレス・ブラウザ情報・利用日時）</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold text-gray-800">3. 利用目的</h2>
        <ul className="text-sm text-gray-700 space-y-1 list-disc list-inside">
          <li>本サービスの提供・運営・改善</li>
          <li>ユーザー認証・本人確認</li>
          <li>サブスクリプション・決済の処理</li>
          <li>お問い合わせへの対応</li>
          <li>不正利用の防止</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold text-gray-800">4. 第三者提供</h2>
        <p className="text-sm text-gray-700">
          当社は、以下の場合を除きユーザーの個人情報を第三者に提供しません。
        </p>
        <ul className="text-sm text-gray-700 space-y-1 list-disc list-inside">
          <li>ユーザーの同意がある場合</li>
          <li>法令に基づく場合</li>
          <li>業務委託先への提供（決済処理：Stripe, Inc.）</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold text-gray-800">5. 外部サービスの利用</h2>
        <p className="text-sm text-gray-700">
          本サービスは以下の外部サービスを利用しています。各サービスのプライバシーポリシーもご確認ください。
        </p>
        <ul className="text-sm text-gray-700 space-y-1 list-disc list-inside">
          <li>X（旧Twitter）: ログイン認証に使用</li>
          <li>Stripe, Inc.: 決済処理に使用</li>
          <li>Cloudflare: 画像配信に使用</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold text-gray-800">6. Cookie・アクセス解析</h2>
        <p className="text-sm text-gray-700">
          本サービスはログイン状態の維持のためにCookieを使用します。
          ブラウザの設定によりCookieを無効にすることができますが、一部機能が利用できなくなる場合があります。
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold text-gray-800">7. 個人情報の管理・削除</h2>
        <p className="text-sm text-gray-700">
          ユーザーは、当社が保有する自身の個人情報の開示・訂正・削除を求めることができます。
          お問い合わせフォームよりご連絡ください。
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold text-gray-800">8. お問い合わせ</h2>
        <p className="text-sm text-gray-700">
          個人情報の取扱いに関するお問い合わせは、下記までご連絡ください。<br />
          株式会社木村技研<br />
          メール：k.tsuyoshi@kimura-giken.net
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold text-gray-800">9. ポリシーの変更</h2>
        <p className="text-sm text-gray-700">
          本ポリシーは必要に応じて改定することがあります。重要な変更がある場合はサービス上でお知らせします。
        </p>
      </section>
    </div>
  );
}
